(function() {
  const SELECTOR = '[data-cart-count]';

  function updateCartBadge() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll(SELECTOR).forEach(el => {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.style.display = 'inline-block';
          } else {
            el.textContent = ''; // limpiar el texto (sin mostrar el 0)
            el.style.display = 'none'; // ocultar el badge
          }
        });
        apply();
        setTimeout(apply, 300); // 👈 repetir tras 300ms para sobrescribir el 0 del theme
      })
      .catch(err => console.warn('Cart badge error:', err));
  }

  function initObserver() {
    if (!document.body) return;
    const observer = new MutationObserver(mutations => {
      let needsUpdate = false;
      for (const m of mutations) {
        // si el nodo afectado es el contador o dentro del minicart, actualiza
        if (m.target.matches?.(SELECTOR) || m.target.closest?.('#CartDrawer')) {
          needsUpdate = true;
          break;
        }
      }
      if (needsUpdate) updateCartBadge();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Ejecutar al cargar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateCartBadge();
      initObserver();
    });
  } else {
    updateCartBadge();
    initObserver();
  }

  // Extra: detectar clicks en add y remove
  document.addEventListener('click', e => {
    if (
      e.target.closest('form[action*="/cart/add"], [data-add-to-cart], .add-to-cart, [data-cart-remove], .cart-remove')
    ) {
      setTimeout(updateCartBadge, 400);
    }
  });
})();